import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaFileDownload, FaBook, FaCalendarAlt, FaFilePdf } from 'react-icons/fa';

function DownloadsContainer() {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className='min-h-screen p-6 md:p-12'>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
                {/* <div
                    className='flex flex-col bg-white rounded-xl overflow-hidden shadow-[0_5px_15px_rgba(183,32,46,0.1)] hover:shadow-[0_8px_25px_rgba(183,32,46,0.15)] hover:-translate-y-1 transition-all duration-300 h-full relative p-6 border-t-4 border-t-[#B7202E]'
                    data-aos="zoom-in"
                >
                    <div className="text-[2.5rem] text-[#B7202E] mb-4 flex items-center justify-center h-20 bg-[#B7202E]/10 rounded-lg">
                        <FaBook />
                    </div>
                    <div className="flex-grow mb-5">
                        <h3 className="text-[#B7202E] text-xl font-bold mb-2">How to use Website</h3>
                        <p className="text-gray-600 text-[0.95rem] leading-relaxed">A guide to navigate and utilize all features of the website</p>
                    </div>
                    <a href="/path/to/pdf1.pdf" download className="inline-flex items-center gap-2 bg-[#B7202E] text-white px-5 py-2.5 rounded-md font-semibold hover:bg-[#971825] transition-colors self-start shadow-sm">
                        <FaFileDownload /> Download
                    </a>
                </div> */}

                <div
                    className='flex flex-col bg-white rounded-xl overflow-hidden shadow-[0_5px_15px_rgba(183,32,46,0.1)] hover:shadow-[0_8px_25px_rgba(183,32,46,0.15)] hover:-translate-y-1 transition-all duration-300 h-full relative p-6 border-t-4 border-t-[#B7202E]'
                    data-aos="zoom-in"
                    data-aos-delay="100"
                >
                    <div className="text-[2.5rem] text-[#B7202E] mb-4 flex items-center justify-center h-20 bg-[#B7202E]/10 rounded-lg">
                        <FaCalendarAlt />
                    </div>
                    <div className="flex-grow mb-5">
                        <h3 className="text-[#B7202E] text-xl font-bold mb-2">Projects Timeline</h3>
                        <p className="text-gray-600 text-[0.95rem] leading-relaxed">Important dates and deadlines for project submissions</p>
                    </div>
                    <a href="https://drive.google.com/file/d/1AqFCKGCNFxKmqmHkkAb6Eyf5cPlxE3aD/view?usp=sharing" className="inline-flex items-center gap-2 bg-[#B7202E] text-white px-5 py-2.5 rounded-md font-semibold hover:bg-[#971825] transition-colors self-start shadow-sm">
                        <FaFileDownload /> Download
                    </a>
                </div>

                {/* <div
                    className='flex flex-col bg-white rounded-xl overflow-hidden shadow-[0_5px_15px_rgba(183,32,46,0.1)] hover:shadow-[0_8px_25px_rgba(183,32,46,0.15)] hover:-translate-y-1 transition-all duration-300 h-full relative p-6 border-t-4 border-t-[#B7202E]'
                    data-aos="zoom-in"
                    data-aos-delay="200"
                >
                    <div className="text-[2.5rem] text-[#B7202E] mb-4 flex items-center justify-center h-20 bg-[#B7202E]/10 rounded-lg">
                        <FaFilePdf />
                    </div>
                    <div className="flex-grow mb-5">
                        <h3 className="text-[#B7202E] text-xl font-bold mb-2">Resource Guide</h3>
                        <p className="text-gray-600 text-[0.95rem] leading-relaxed">Additional resources and materials for your projects</p>
                    </div>
                    <a href="/path/to/pdf3.pdf" download className="inline-flex items-center gap-2 bg-[#B7202E] text-white px-5 py-2.5 rounded-md font-semibold hover:bg-[#971825] transition-colors self-start shadow-sm">
                        <FaFileDownload /> Download
                    </a>
                </div> */}
            </div>
        </div>
    );
}

export default DownloadsContainer;